module.exports = __webpack_public_path__ + "img/Icon (1).fab9f4a.png";